import { render } from "./IknowaLogoBlack.vue?vue&type=template&id=655f2115"
import script from "./IknowaLogoBlack.vue?vue&type=script&lang=js"
export * from "./IknowaLogoBlack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__